// import getCookie from "./getCookie";

async function validateLink(link: string): Promise<number> {
  try {

    const url = `https://ruuf-backend.online/auth/receive-magic-link`;
    const timeout = new Promise<number>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 3000),
    );

    const response = await Promise.race([
      fetch(url, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ magicLink: link }),
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    const data = await response.json();

    if (response.status === 200) {
      console.log("Magic-Link is valid");
      console.log(data.message);
      // // get the setted cookie from the backend
      // const cookie = getCookie("connect.sid");
      // console.log("Cookie received: ", cookie);
      // // set cookie for the domain again
      // document.cookie = `connect.sid=${cookie}`;
      // console.log("Cookie setted: ", cookie);
      return 0; // link is valid
    } else if (response.status === 400) {
      if (data.message === "Magic-Link has expired") {
        console.error("Magic-Link has expired");
        return 1; // link has expired
      } else if (data.message === "Invalid Magic-Link") {
        console.error("Invalid Magic-Link");
        return 2; // Invalid link
      }
    } else {
      throw new Error("Unexpected response status");
    }
  } catch (error) {
    console.error("Error validating magic-link:", error);
    return -1; // Error validating link
  }
  return -1; // Error validating link
}

export default validateLink;
